import { render, staticRenderFns } from "./AdminBaseSources.vue?vue&type=template&id=66533f46"
import script from "./AdminBaseSources.vue?vue&type=script&lang=js"
export * from "./AdminBaseSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports